import { getLocalTimeZone } from '@internationalized/date';
import { useMemo } from 'react';
import { useGlobal } from '@/store';
import { useContentReview } from '@/store/content-review';
import { toUnix } from '@/utils/date';
import { QueriesRecordFiltersSection } from './components/filters-section';
import { RecordReportsTable } from './components/list';

export const QueriesReviewPage = () => {
  const search = useContentReview.use.search();
  const createdAt = useContentReview.use.createdAt();
  const createdBy = useContentReview.use.createdBy();
  const recordIds = useContentReview.use.recordIds();
  const type = useContentReview.use.type();
  const dbType = useGlobal.use.dbType();
  const state = useContentReview.use.state();
  const withRecords = useContentReview.use.withRecords();
  const actionedBy = useContentReview.use.actionedBy();

  const createdAtUnix = useMemo(() => {
    if (!createdAt) return undefined;
    const date = createdAt.toDate ? createdAt.toDate(getLocalTimeZone()) : new Date(createdAt.toString());
    return toUnix(date);
  }, [createdAt]);

  const filterKey = useMemo(
    () => JSON.stringify({ search, createdAtUnix, createdBy, recordIds, type, state, dbType }),
    [search, createdAtUnix, createdBy, recordIds, type, state, dbType],
  );

  return (
    <div className='flex flex-col h-full gap-4'>
      <div className='flex flex-col gap-4 md:flex-row md:items-center md:justify-between'>
        <QueriesRecordFiltersSection />
      </div>
      <div className='overflow-x-auto w-full'>
        <RecordReportsTable
          filterKey={filterKey}
          state={state}
          type={type}
          actionedBy={actionedBy}
          title='Help Scout'
          withRecords={withRecords}
        />
      </div>
    </div>
  );
};
